import React from 'react'
import { Link } from 'react-router-dom';
const PlSection_1 = () => {
    return (
        <div className="container">
            <div className="text-center px-20">
                <div className="section-heading">
                    <div className="title-wrapper">
                        <h2 className="section-title has_fade_anim fs-4x  text-grad-1">TruVoice Platform</h2>
                    </div>
                    <div className="text-wrapper">
                        <p className="text has_fade_anim mt-3 fs-1  text-grad-3">
                            Use this simple intuitive UI to make full-featured AI Agents. This no-code platform allows you to create in-depth conversational experience in a few clicks. TruVoice platform comes with many in-built conversation-handlers which maximizes your customer’s experience.
                        </p>
                    </div>
                    <div className="btn-wrap has_fade_anim mt-10">
                        <Link to="#how-its-works" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4">
                            <span data-text="How it works?">How it works?</span>
                        </Link>
                        <Link to="#developer-guide" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4">
                            <span data-text="Developer Guide">Developer Guide</span>
                        </Link>
                        <Link to="#pricing" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 fs-4 me-5">
                            <span data-text="Pricing">Pricing</span>
                        </Link>
                        <Link to="#integration" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 fs-4">
                            <span data-text="Channels">Channels</span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export {PlSection_1}